module.exports = __webpack_public_path__ + "94b9d05f34478bb7efb1f2c017d6b387.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1_variable/public/news/img1_3.jpg
// module id = 426
// module chunks = 0